import React, { PureComponent } from 'react';
import { injectIntl, defineMessages } from 'react-intl';

import { Icon } from 'semantic-ui-react';
import Tooltip from 'material-ui/Tooltip';
import { AdminUserEditModal } from 'components';

import { CtAdminUserDelete } from 'containers';

import classNames from 'classnames/bind';
import styles from './AdminUserInTableMenu.css';
const cx = classNames.bind(styles);

class AdminUserInTableMenu extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      deleteModal: false,
      editModal: false
    };
  }

  mountDeleteModal = () => {
    this.setState({ deleteModal: !this.state.deleteModal });
  };

  mountEditModal = () => {
    this.setState({ editModal: !this.state.editModal });
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { deleteModal, editModal } = this.state;
    const { isAuth, userInfo } = this.props;
    const { mountDeleteModal, mountEditModal } = this;

    const { userEnabled } = userInfo;

    return (
      <div className={'inline-conf-area'}>
        <Tooltip
          title={defineMessages(formatMessage({ id: 'AdminUserInTableMenu_1', defaultMessage: '사용자 수정' }))}
          placement="bottom">
          <Icon color="grey" className={cx('icon-edit')} name="edit" link onClick={mountEditModal} />
        </Tooltip>
        {editModal && <AdminUserEditModal isAuth={isAuth} userInfo={userInfo} mountEditModal={mountEditModal} />}

        {userEnabled === 1 && (
          <Tooltip
            title={defineMessages(formatMessage({ id: 'AdminUserInTableMenu_2', defaultMessage: '사용자 삭제' }))}
            placement="bottom">
            <Icon color="grey" className="icon-remove" name="remove circle" link onClick={mountDeleteModal} />
          </Tooltip>
        )}
        {deleteModal && <CtAdminUserDelete userInfo={userInfo} mountDeleteModal={mountDeleteModal} />}
      </div>
    );
  }
}

export default injectIntl(AdminUserInTableMenu);



// WEBPACK FOOTER //
// ./src/script/components/admin/user/AdminUserInTableMenu.js